import Icon from "./IconBase";

const ChevronRightIcon = (props) => (
  <Icon width="9" height="14" viewBox="-1 0 9 14" {...props} fill="#A1AEB7">
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 13L7 7L1 1"
        stroke="#0F0F0F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Icon>
);

export default ChevronRightIcon;
